import warningIcon from "../../asessts/Images/warning_icon.svg";

const LogoutPopup = ({ handleLogout, handlePopupClose, isLogoutPopup }) => {
  return (
    <div className={`overlay ${isLogoutPopup ? "logout-main-active" : ""}`}>
      <div class={`logout-main ${isLogoutPopup ? "logout-main-active" : ""}`}>
        <button class="delete-icon">
          <img src={warningIcon} alt="icon" />
        </button>
        <h2>Please Confirm!</h2>
        <p>Are you sure, you want to logout?</p>
        <div className="block-btn">
          <button
            onClick={handlePopupClose}
            className="cancle-btn"
            style={{ cursor: "pointer" }}
          >
            Cancel
          </button>

          <button
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
            className="logout-btn"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};
export default LogoutPopup;
